﻿import Image from "../image";
import ActivePage from "../activePage";

export default class MatterPage extends ActivePage {

    constructor() {
        super();
        this.image = new Image();
        this.showOutstandingActionsOnly = true;
        this.patMenuChoice = null;
        this.tmkMenuChoice = null;
        this.caseNumberSearchValueMapperUrl = "";
    }

    init(addMode, isClientMatterOn, screen) {
        this.tabsLoaded = [];
        this.tabChangeSetListener();

        $(document).ready(() => {
            if (addMode) {
                if (isClientMatterOn) {
                    const client = this.getKendoComboBox("ClientID");
                    client.input.focus();
                }
                else {
                    const respOffice = this.getKendoComboBox("RespOffice");
                    if (respOffice) {
                        respOffice.input.focus();
                    }
                    else {
                        const caseNumber = this.getElement("CaseNumber");
                        caseNumber.focus();
                    }
                }
            } 

            const countriesGrid = $("#gmCountriesGrid");
            countriesGrid.on("click", ".countryLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = countriesGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.Country);
                pageHelper.openLink(linkUrl, false);
            });

            const attorneysGrid = $("#gmAttorneysGrid");
            attorneysGrid.on("click", ".attorneyLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = attorneysGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.AttorneyID);
                pageHelper.openLink(linkUrl, false);
            });

            const otherPartiesGrid = $("#gmOtherPartiesGrid");
            otherPartiesGrid.on("click", ".otherPartyLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = otherPartiesGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.OtherParty);
                pageHelper.openLink(linkUrl, false);
            });
            //otherPartiesGrid.on("click", ".contactLink", (e) => {
            //    e.stopPropagation();

            //    let url = $(e.target).data("url");
            //    const row = $(e.target).closest("tr");
            //    const dataItem = otherPartiesGrid.data("kendoGrid").dataItem(row);
            //    const linkUrl = url.replace("actualValue", dataItem.Contact.ContactID);
            //    pageHelper.openLink(linkUrl, false);
            //});
            otherPartiesGrid.on("click", ".otherPartyTypeLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = otherPartiesGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.OtherPartyType);
                pageHelper.openLink(linkUrl, false);
            });

            const productsGrid = $(`#productsGrid_${this.mainDetailContainer}`);
            productsGrid.on("click", ".productLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = productsGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.ProductId);
                pageHelper.openLink(linkUrl, false);
            });

            const actionsGrid = $(`#actionsGrid_${this.mainDetailContainer}`);
            actionsGrid.on("click", ".action-link", (e) => {
                e.stopPropagation();
                e.preventDefault();

                if (this.actionActIds && this.actionActIds.length > 0) {
                    gmActionDuePage.mainSearchRecordIds = this.actionActIds;
                }
                const link = $(e.target);
                pageHelper.openDetailsLink(link);
            });

            $("#IsObligationContinue").change(function (e) {
                $(".obligation-length").removeClass("d-none").hide();
                if (e.target.checked) 
                    $(".obligation-length").show();
            })

            if (document.getElementById("StartTimeTrack") != null) {
                $("#StartTimeTrack").off("click").on("click", function (e) {
                    let url = $(e.target).closest("#StartTimeTrack").data("url");
                    $.ajax({
                        type: "POST",
                        url: url,
                        contentType: false, // needed for file upload
                        processData: false, // needed for file upload
                        success: (result) => {
                            pageHelper.showSuccess(result.success);
                            document.getElementById("StartTimeTrack").setAttribute("hidden", "hidden");
                            document.getElementById("StopTimeTrack").removeAttribute("hidden");
                        },
                        error: function (e) {
                            pageHelper.showErrors(e);
                        }
                    });
                });
            }
        });

        this.emphasizeInactiveStatus(screen);
    }

    emphasizeInactiveStatus = (screen) => {
        $(document).ready(function () {
            const form = $(`#${screen}`).find("form");
            const activeSwitch = form.find("#IsActive");
            if (activeSwitch.val() === "False") {
                form.find("input[name='MatterStatus_input']").attr("style", "color: #dc3545 !important");
            }
        });
    }

    caseNumberSearchValueMapper = (options) => {
        const url = this.getCaseNumberSearchValueMapper();
        $.ajax({
            url: url,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });
    }

    getCaseNumberSearchValueMapper = () => {
        if (this.caseNumberSearchValueMapperUrl === "") {
            this.caseNumberSearchValueMapperUrl = $("#matterSearchCaseInfoTabContent").data("case-number-mapper-url");
            if (this.caseNumberSearchValueMapperUrl === undefined || this.caseNumberSearchValueMapperUrl === "")
                this.caseNumberSearchValueMapperUrl = $("#docMgtMainTabContent").data("case-number-mapper-url");
        }
        return this.caseNumberSearchValueMapperUrl;
    }

    onMatterTypeSelect(e) {
        if (e.item) {
            $(".agreement-info").removeClass("d-none").hide();
            $(".court-info").removeClass("d-none").hide();

            if (e.dataItem["MatterType"].toLowerCase() === "agreement") {
                $(".agreement-info").show();
            }

            if (e.dataItem["MatterType"].toLowerCase() === "litigation") {
                $(".court-info").show();
            }
        }
    }

    tabChangeSetListener() {
        $('#matterTab a').on('click', (e) => {
            e.preventDefault();
            const tab = e.target.id;
            if (this.tabsLoaded.indexOf(tab) === -1) {
                this.tabsLoaded.push(tab);
                this.loadTabContent(tab);
            }
        });
    }

    showDetails(result) {
        let id = result;
        if (isNaN(result))
            id = result.id;

        pageHelper.showDetails(this, id, () => {
            pageHelper.handleEmailWorkflow(result);
            //this.handleSaveWorkflow(result);
        });
    }

    //handleSaveWorkflow = (result) => {
    //    if (result.emailWorkflows) {
    //        let promise = this.processEmailWorkflow(result.id, result.emailWorkflows[0].isAutoEmail, result.emailWorkflows[0].qeSetupId, result.emailWorkflows[0].autoAttachImages);
    //        for (let i = 1; i < result.emailWorkflows.length; i++) {
    //            const workflow = result.emailWorkflows[i];
    //            promise = promise.then(() => {
    //                return this.processEmailWorkflow(result.id, workflow.isAutoEmail, workflow.qeSetupId, workflow.autoAttachImages);
    //            });
    //        }
    //    }
    //}

    //processEmailWorkflow = (id, isAutoEmail, qeSetupId, autoAttachImages) => {
    //    const deferred = $.Deferred();
    //    const baseUrl = $("body").data("base-url");
    //    let url = `${baseUrl}/GeneralMatter/Matter/Email`;

    //    $.get(url, { id: id, sendImmediately: isAutoEmail, qeSetupId: qeSetupId, autoAttachImages: autoAttachImages  })
    //        .done((emailResult) => {
    //            if (!isAutoEmail) {
    //                const popupContainer = $(".cpiContainerPopup").last();
    //                popupContainer.html(emailResult);
    //                const dialog = $("#quickEmailDialog");
    //                dialog.modal("show");
    //                dialog.find("#ok, #cancel,.close").on("click", () => {
    //                    $(".modal-backdrop").remove();
    //                    deferred.resolve();
    //                });
    //            }
    //            else deferred.resolve();
    //        })
    //        .fail(function (error) {
    //            pageHelper.showErrors(error.responseText);
    //            deferred.resolve();
    //        });
    //    return deferred.promise();
    //}

    deleteDueDate = (e, grid, deleteActionDuePrompt) => {
        this.deleteGridRow(e, grid);
    }

    loadTabContent(tab) {
        switch (tab) {
            case "matterDetailEntitiesTab":
                $(document).ready(() => {
                    const grid = $("#gmAttorneysGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;

            case "matterDetailOtherPartiesTab":
                $(document).ready(() => {
                    const grid = $("#gmOtherPartiesGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;

            case "matterDetailPatentsTab":
                $(document).ready(() => {
                    this.handleRelatedPatentsMenu();
                });
                break;                

            case "matterDetailTrademarksTab":
                $(document).ready(() => {
                    this.handleRelatedTrademarksMenu();
                });
                break;  

            case "matterDetailRelatedMattersTab":
                $(document).ready(() => {
                    const grid = $("#gmMatterRelatedMattersGrid").data("kendoGrid");
                    grid.dataSource.read();                    
                });
                break;

            case "matterDetailKeywordsTab":
                $(document).ready(() => {
                    const grid = $("#keywordsGridgmMatterDetail").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;

            case "matterDetailDocumentsTab":
                $(document).ready(() => {
                    this.image.initializeImage(this);
                });
                break;

            case "matterDetailCostsTab":
                $(document).ready(() => {
                    const costsGrid = $(`#costsGrid_${this.mainDetailContainer}`);                    
                    const grid = costsGrid.data("kendoGrid");
                    grid.dataSource.read();
                    pageHelper.addBreadCrumbsRefreshHandler(costsGrid, () => {
                        grid.dataSource.read();
                        this.updateRecordStamps();
                    });
                });
                break;

            case "matterDetailActionsTab":
                $(document).ready(() => {
                    const actionsGrid = $(`#actionsGrid_${this.mainDetailContainer}`);
                    const grid = actionsGrid.data("kendoGrid");
                    $(".grid-options #showOutstandingActionsOnly").prop('checked', this.showOutstandingActionsOnly);
                    if (parseInt(grid.options.dataSource.pageSize) > 0)
                        grid.dataSource.pageSize(grid.options.dataSource.pageSize);
                    else
                        grid.dataSource.read();

                    pageHelper.addBreadCrumbsRefreshHandler(actionsGrid, () => {
                        grid.dataSource.read();
                        this.updateRecordStamps();
                    });
                });
                break;

            case "matterDetailCorrespondenceTab":
                $(document).ready(() => {
                    const docsOutGrid = $(`#docsOutGrid_${this.mainDetailContainer}`).data("kendoGrid");
                    docsOutGrid.dataSource.read();
                });
                break;

            case "matterDetailProductsTab":
                $(document).ready(() => {
                    const productsGrid = $(`#${this.mainDetailContainer}`).find(`#productsGrid_${this.mainDetailContainer}`).data("kendoGrid");
                    if (productsGrid)
                        productsGrid.dataSource.read();
                });
                break;

            case "":
                break;
        }
    }

    handleRelatedPatentsMenu() {
        const relatedPatentInfo = $("#relatedPatentInfo");

        const url = relatedPatentInfo.data("url");
        const data = {
            matId: relatedPatentInfo.data("matid"),
            patMenuChoice: this.patMenuChoice ? this.patMenuChoice : "OurPatents"
        };

        this.loadOurPat = true;
        this.loadOtherPartyPat = true;

        const self = this;
        relatedPatentInfo.find("a").click(function () {           
            const selected = $(this).data("value");
            data.patMenuChoice = selected;
            self.loadPatentGrid(url, data);

        });
        this.loadPatentGrid(url, data);       
    }

    loadPatentGrid(url, data) {

        if (this.loadOurPat || this.loadOtherPartyPat) {
            $.get(url, data)
                .done((html) => {                    
                    if (data.patMenuChoice === "OurPatents") {
                        const tabContent = $("#ourPatentTabContent");
                        tabContent.html(html);
                        if (!tabContent.hasClass("active"))
                            tabContent.addClass("active")

                        this.setOurPatentSettings();
                    } else {
                        const tabContent = $("#otherPartyPatentTabContent");
                        tabContent.html(html);
                        if (!tabContent.hasClass("active"))
                            tabContent.addClass("active")

                        this.setOtherPartyPatentSettings();
                    }
                })
                .fail(function (e) {
                    pageHelper.showErrors(e.responseText);
                });
        }

    }

    setOurPatentSettings() {
        if (this.loadOurPat) {
            const name = "gmMatterPatentsGrid";
            const el = $(`#${name}`);
            const grid = el.data("kendoGrid");
            const self = this;

            if (grid) {
                grid.dataSource.read();
                this.loadOurPat = false;
                const matId = el.closest("div").data("matid");

                if (!this.isEditableGridRegistered(name)) {
                    const gridInfo = {
                        name: name,
                        isDirty: false,
                        filter: { parentId: matId },
                        afterSubmit: this.updateRecordStamps
                    };
                    this.addEditableGrid(gridInfo);
                    pageHelper.kendoGridDirtyTracking(el, gridInfo);
                }
            }
        }
    }

    setOtherPartyPatentSettings() {
        if (this.loadOtherPartyPat) {
            const name = "gmOtherPartyPatentsGrid";
            const el = $(`#${name}`);
            const grid = el.data("kendoGrid");
            const self = this;

            if (grid) {
                grid.dataSource.read();
                this.loadOtherPartyPat = false;
                const matId = el.closest("div").data("matid");

                if (!this.isEditableGridRegistered(name)) {
                    const gridInfo = {
                        name: name,
                        isDirty: false,
                        filter: { parentId: matId },
                        afterSubmit: this.updateRecordStamps
                    };
                    this.addEditableGrid(gridInfo);    
                    pageHelper.kendoGridDirtyTracking(el, gridInfo);
                }
            }
        }
    }

    handleRelatedTrademarksMenu() {
        const relatedTrademarkInfo = $("#relatedTrademarkInfo");

        const url = relatedTrademarkInfo.data("url");
        const data = {
            matId: relatedTrademarkInfo.data("matid"),
            tmkMenuChoice: this.tmkMenuChoice ? this.tmkMenuChoice : "OurTrademarks"
        };

        this.loadOurTmk = true;
        this.loadOtherPartyTmk = true;

        const self = this;
        relatedTrademarkInfo.find("a").click(function () {
            const selected = $(this).data("value");
            data.tmkMenuChoice = selected;
            self.loadTrademarkGrid(url, data);

        });
        this.loadTrademarkGrid(url, data);
    }

    loadTrademarkGrid(url, data) {

        if (this.loadOurTmk || this.loadOtherPartyTmk) {
            $.get(url, data)
                .done((html) => {
                    if (data.tmkMenuChoice === "OurTrademarks") {
                        const tabContent = $("#ourTrademarkTabContent");
                        tabContent.html(html);
                        if (!tabContent.hasClass("active"))
                            tabContent.addClass("active")

                        this.setOurTrademarkSettings();
                    } else {
                        const tabContent = $("#otherPartyTrademarkTabContent");
                        tabContent.html(html);
                        if (!tabContent.hasClass("active"))
                            tabContent.addClass("active")

                        this.setOtherPartyTrademarkSettings();
                    }
                })
                .fail(function (e) {
                    pageHelper.showErrors(e.responseText);
                });
        }

    }

    setOurTrademarkSettings() {
        if (this.loadOurTmk) {
            const name = "gmMatterTrademarksGrid";
            const el = $(`#${name}`);
            const grid = el.data("kendoGrid");
            const self = this;

            if (grid) {
                grid.dataSource.read();
                this.loadOurTmk = false;
                const matId = el.closest("div").data("matid");

                if (!this.isEditableGridRegistered(name)) {
                    const gridInfo = {
                        name: name,
                        isDirty: false,
                        filter: { parentId: matId },
                        afterSubmit: this.updateRecordStamps
                    };
                    this.addEditableGrid(gridInfo);
                    pageHelper.kendoGridDirtyTracking(el, gridInfo);
                }
            }
        }
    }

    setOtherPartyTrademarkSettings() {
        if (this.loadOtherPartyTmk) {
            const name = "gmOtherPartyTrademarksGrid";
            const el = $(`#${name}`);
            const grid = el.data("kendoGrid");
            const self = this;

            if (grid) {
                grid.dataSource.read();
                this.loadOtherPartyTmk = false;
                const matId = el.closest("div").data("matid");

                if (!this.isEditableGridRegistered(name)) {
                    const gridInfo = {
                        name: name,
                        isDirty: false,
                        filter: { parentId: matId },
                        afterSubmit: this.updateRecordStamps
                    };
                    this.addEditableGrid(gridInfo);
                    pageHelper.kendoGridDirtyTracking(el, gridInfo);
                }
            }
        }
    }

    caseNumberDetailValueMapper(options) {
        const url = gmMatterPage.caseNumberDetailValueMapperUrl;

        $.ajax({
            url: url,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });
    }

    onChange_RelatedMatter = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");

            const caseNumber = e.dataItem["CaseNumber"];
            const title = e.dataItem["MatterTitle"];
            const status = e.dataItem["MatterStatus"];           

            const grid = $("#gmMatterRelatedMattersGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);
            dataItem.RelatedId = e.dataItem["RelatedId"];
            dataItem.MatterTitle = title;
            dataItem.MatterStatus = status;  
            dataItem.CaseNumber = caseNumber;

            $(row).find(".caseNumber-field").html(kendo.htmlEncode(caseNumber));
            $(row).find(".matterTitle-field").html(kendo.htmlEncode(title));
            $(row).find(".matterStatus-field").html(kendo.htmlEncode(status));          

        }
    }   

    filterCtryApp = (e) => {
        var grid = $("#gmMatterPatentsGrid").data("kendoGrid");
        var selectedData = grid.dataItem(grid.select());

        return {
            InvID: selectedData.InvID,
            request: e
        };
    }

    onChange_RelatedPatentInv = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
                        
            const country = e.dataItem["Country"] = null;
            const subCase = e.dataItem["SubCase"] = null;
            const caseType = e.dataItem["CaseType"] = null;
            const Patent = e.dataItem["Patent"];

            const grid = $("#gmMatterPatentsGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);
            dataItem.InvID = e.dataItem["InvID"];
            dataItem.Patent = Patent;            
            dataItem.caseNumber = e.dataItem["CaseNumber"];

            dataItem.AppID = e.dataItem["AppID"] = null;
            dataItem.Country = country;
            dataItem.SubCase = subCase;
            dataItem.CaseType = caseType;
            dataItem.AppNumber = e.dataItem["AppNumber"] = null;
            dataItem.PubNumber = e.dataItem["PubNumber"] = null;
            dataItem.PatNumber = e.dataItem["PatNumber"] = null;   

            $(row).find(".country-field").html(kendo.htmlEncode(country));
            $(row).find(".subCase-field").html(kendo.htmlEncode(subCase));
            $(row).find(".caseType-field").html(kendo.htmlEncode(caseType));
            
            $(row).find(".title-field").html(kendo.htmlEncode(Patent));
        }
    }

    onChange_RelatedPatentCtryApp = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");

            const subCase = e.dataItem["SubCase"];
            const caseType = e.dataItem["CaseType"];
            const Patent = e.dataItem["Patent"];

            const grid = $("#gmMatterPatentsGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);
            dataItem.AppID = e.dataItem["AppID"];
            dataItem.Country = e.dataItem["Country"];
            dataItem.SubCase = subCase;
            dataItem.CaseType = caseType;
            dataItem.Patent = Patent;
            dataItem.caseNumber = e.dataItem["CaseNumber"];
            dataItem.AppNumber = e.dataItem["AppNumber"];
            dataItem.PubNumber = e.dataItem["PubNumber"];
            dataItem.PatNumber = e.dataItem["PatNumber"]; 

            $(row).find(".subCase-field").html(kendo.htmlEncode(subCase));
            $(row).find(".caseType-field").html(kendo.htmlEncode(caseType));
            $(row).find(".title-field").html(kendo.htmlEncode(Patent));

        }
    }

    onChange_RelatedTrademark = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");

            const country = e.dataItem["Country"];
            const subCase = e.dataItem["SubCase"];
            const caseType = e.dataItem["CaseType"];
            const trademarkName = e.dataItem["Trademark"];

            const grid = $("#gmMatterTrademarksGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);
            dataItem.TmkId = e.dataItem["TmkId"];
            dataItem.Country = country;
            dataItem.SubCase = subCase;
            dataItem.CaseType = caseType;
            dataItem.Trademark = trademarkName;
            dataItem.AppNumber = e.dataItem["AppNumber"];
            dataItem.PubNumber = e.dataItem["PubNumber"];
            dataItem.RegNumber = e.dataItem["RegNumber"];
            dataItem.caseNumber = e.dataItem["CaseNumber"];

            $(row).find(".country-field").html(kendo.htmlEncode(country));
            $(row).find(".subCase-field").html(kendo.htmlEncode(subCase));
            $(row).find(".caseType-field").html(kendo.htmlEncode(caseType));
            $(row).find(".trademarkName-field").html(kendo.htmlEncode(trademarkName));

        }
    }    

    //------------------------------------------------------------ COPY
    showCopyScreen() {
        //const popupContainer = $(".cpiContainerPopup").last();
        const popupContainer = $(".site-content .popup").last();
        const dialogContainer = popupContainer.find("#gmMatterCopyDialog");
        let entryForm = dialogContainer.find("form")[0];
        dialogContainer.modal("show");
        const self = this;
       
        //$(dialogContainer.find("#tmkCopyButton")).click(function () { self.copyTrademarks(); });

        entryForm = $(entryForm);
        const afterSubmit = function (result) {
            const dataContainer = $('#' + self.mainDetailContainer).find(".cpiDataContainer");
            if (dataContainer.length > 0) {
                setTimeout(function () {
                    dataContainer.empty();
                    dataContainer.html(result);
                }, 1000);
            }
        };
        entryForm.cpiPopupEntryForm({ dialogContainer: dialogContainer, afterSubmit: afterSubmit });
    }

    mainCopyInitialize = (copyMatId) => {
        const baseUrl = $("body").data("base-url");
        const mainUrl = `${baseUrl}/GeneralMatter/Matter`;

        $(document).ready(() => {
            const container = $("#gmMatterCopyDialog");
            container.find(".case-info-settings").hide();

            container.on("click", ".case-info-set", () => {
                container.find(".case-info-settings").show();
                container.find(".data-to-copy").hide();

                const url = `${mainUrl}/GetCopySettings`;
                $.get(url, { copyMatId: copyMatId})                    
                    .done(function (result) {
                        container.find(".case-info-settings-fields").html(result);
                    })
                    .fail(function (e) {
                        pageHelper.showErrors(e.responseText);
                    });
            });
            container.on("click", ".case-info-set-cancel,.case-info-set-save", () => {
                container.find(".case-info-settings").hide();
                container.find(".data-to-copy").show();
            });
            container.on("change", ".case-info-settings-fields input[type='checkbox']", function () {
                const checkbox = $(this);
                const name = checkbox.attr("name");
                const value = checkbox.prop("checked");
                const url = `${mainUrl}/UpdateCopySetting`;
                $.post(url, { copySettingId: name, copy: value })
                    .fail(function (e) {
                        pageHelper.showErrors(e.responseText);
                    });
            });
        });
    }

    /* product */
    onChange_Product = (e) => {
        if (e.sender) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
            const grid = $("#productsGrid_gmMatterDetail").data("kendoGrid");
            const dataItem = grid.dataItem(row);

            var comboDataItem = e.sender.dataItem();
            dataItem.ProductId = comboDataItem["ProductId"];
            dataItem.ProductName = comboDataItem["ProductName"];

        }
    }
    productRefreshIndicator = (e) => {
        const data = e.sender.dataSource.data();
        if (data.length == 0)
            $("#matterDetailProductsTab").removeClass("has-products");
        else
            $("#matterDetailProductsTab").addClass("has-products");
    }

    onDueDateAttorneyChange = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
            const grid = $(`#actionsGrid_${this.mainDetailContainer}`).data("kendoGrid");
            const dataItem = grid.dataItem(row);

            dataItem.AttorneyID = e.dataItem["AttorneyID"];
        }
    }

    clearDueDateAttorney = (e) => {
        const row = $(`#${e.sender.element[0].id}`).closest("tr");
        const grid = $(`#actionsGrid_${this.mainDetailContainer}`).data("kendoGrid");
        const dataItem = grid.dataItem(row);

        if (dataItem.DueDateAttorneyName == null || dataItem.DueDateAttorneyName == "") {
            dataItem.AttorneyID = null;
            dataItem.DueDateAttorneyName == "";
        }
    }

    showDueDateEmailScreen(e, grid) {
        const form = $("#" + this.detailContentContainer).find("form");
        const url = form.data("duedate-email-url");
        const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
        const ddId = dataItem.DDId;

        $.ajax({
            url: url,
            data: { id: ddId },
            success: function (result) {
                const popupContainer = $(".site-content .popup");
                popupContainer.html(result);
            },
            error: function (e) {
                pageHelper.showErrors(e);
            }
        });
    }
}





